import { Button, CircularProgress } from "@material-ui/core";
import { AddCircle, Close, OpenInBrowser } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { db, storage } from "../../../firebase";

function AboutUsTemplate({ type, data, relodAboutUsState }) {
  const [, setrelodAboutUs] = relodAboutUsState;
  const [file, setFile] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [imagesFiles, setImagesFiles] = useState([]);

  const [preview, setPreview] = useState(data.poster);
  const [imagesPreviews, setImagesPreviews] = useState(data.images);
  const [uploadedImagesPreviews, setUploadedImagesPreviews] = useState([]);

  const [description, setDescription] = useState(data.description);

  const [videoTitle, setVideoTitle] = useState("");
  const [videoURL, setVideoURL] = useState("");
  const [videoDesciption, setVideoDesciption] = useState("");

  const [change, setChange] = useState(false);
  const [loading, setLoading] = useState(false);
  const [urls, setUrls] = useState(data.videos);
  // console.log(data?.poster);
  // console.log("rendered for " + type);

  const submitHandler = async () => {
    setLoading(true);
    try {
      let posterURL = data.poster;
      let images = imagesPreviews;
      const storageRef = storage.ref();

      if (file) {
        const ref = storageRef.child(
          `aboutUs/${type}/poster/${new Date().toISOString()}`
        );
        await ref.put(file);
        posterURL = await ref.getDownloadURL();
        setPreview(posterURL);
        setFile(null);
      }

      if (imagesFiles.length !== 0) {
        for (let i = 0; i < imagesFiles.length; i++) {
          let name = new Date().toISOString();
          const ref = storageRef.child(`aboutUs/${type}/images/${name}`);
          await ref.put(imagesFiles[i]);
          const imageUrl = await ref.getDownloadURL();
          images.push({ url: imageUrl, type: 0 });
        }
        setImagesFiles([]);
        setUploadedImagesPreviews([]);
        setImagesPreviews(images);
      }

      if (type === "Hospital") {
        await db
          .collection("HomePageData")
          .doc("AboutUsData")
          .update({
            aboutJainHospital: {
              description,
              poster: posterURL,
              videos: urls,
              images,
            },
          });
      } else if (type === "School") {
        await db
          .collection("HomePageData")
          .doc("AboutUsData")
          .update({
            aboutJainSchool: {
              description,
              poster: posterURL,
              videos: urls,
              images,
            },
          });
      } else if (type === "Temple") {
        await db
          .collection("HomePageData")
          .doc("AboutUsData")
          .update({
            aboutJainTemple: {
              description,
              poster: posterURL,
              videos: urls,
              images,
            },
          });
      }

      setChange(false);
      setLoading(false);
      setrelodAboutUs((p) => !p);
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!file) {
      return;
    }
    setChange(true);
    const fileURL = URL.createObjectURL(file);
    setPreview(fileURL);
  }, [file]);

  useEffect(() => {
    if (!imageFile) {
      return;
    }
    setImagesFiles((p) => [...p, imageFile]);
    const fileURL = URL.createObjectURL(imageFile);
    setUploadedImagesPreviews((p) => [
      ...p,
      { url: fileURL, type: 0, name: imageFile.name },
    ]);
    setChange(true);
    // console.log(imagesPreviews);
  }, [imageFile]);

  const imageRemoveHandlerOriginal = (item) => {
    setImagesPreviews((p) => p.filter((itm) => itm.url !== item.url));
    setChange(true);
  };

  // console.log(imagesFiles);

  const imageRemoveHandlerUploaded = (item) => {
    //console.log(item);//
    setUploadedImagesPreviews((p) => p.filter((itm) => itm.url !== item.url));
    setImagesFiles((p) => p.filter((itm) => itm.name !== item.name));
    setChange(true);
  };

  return (
    <>
      <h1 style={{ textAlign: "left", margin: "20px 10px" }}>{type}</h1>
      <div className="aboutUs__template">
        <div className="aboutUs__posterInput">
          <b style={{ fontSize: "20px" }}>Poster: </b>
          <label htmlFor={`aboutUs__templateInput__poster${type}`}>
            Choose
          </label>
          <input
            type="file"
            accept="image/*"
            id={`aboutUs__templateInput__poster${type}`}
            hidden
            onChange={(e) => setFile(e.target.files[0])}
          />
        </div>
        <div className="aboutUs__posterContainer" style={{ marginTop: "0" }}>
          <div className="aboutUs__poster">
            <img src={preview} alt="" />
          </div>
        </div>

        <p
          style={{
            margin: "0",
            marginTop: "20px",
            fontWeight: "bold",
          }}
        >
          Description:
        </p>
        <textarea
          rows="5"
          placeholder={`About Jain ${type}`}
          style={{
            width: "100%",
            padding: "5px",
            fontSize: "18px",
            fontFamily: "inherit",
            margin: "0",
          }}
          value={description}
          onChange={(e) => {
            setDescription(e.target.value);
            setChange(true);
          }}
        />
        <div>
          <span
            style={{
              margin: "0",
              marginTop: "20px",
              fontWeight: "bold",
            }}
          >
            Images:
          </span>
          <div className="aboutUs__template__allImages">
            {imagesPreviews.map((item) => (
              <div key={item.url} className="aboutUs__template__customUploader">
                <img
                  src={item.url}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                  alt=""
                />
                <div
                  className="aboutUs__template__allImages__closeIcon"
                  onClick={() => imageRemoveHandlerOriginal(item)}
                >
                  <Close />
                </div>
              </div>
            ))}

            {uploadedImagesPreviews.map((item) => (
              <div key={item.url} className="aboutUs__template__customUploader">
                <img
                  src={item.url}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                  alt=""
                />
                <div
                  className="aboutUs__template__allImages__closeIcon"
                  onClick={() => imageRemoveHandlerUploaded(item)}
                >
                  <Close />
                </div>
              </div>
            ))}

            <div className="aboutUs__template__customUploader">
              <label
                htmlFor={`aboutUs__templateInput__images${type}`}
                style={{ cursor: "pointer" }}
              >
                <AddCircle style={{ fontSize: "100px", color: "#f76b1c" }} />
              </label>
            </div>

            <input
              type="file"
              accept="image/*"
              id={`aboutUs__templateInput__images${type}`}
              onChange={(e) => setImageFile(e.target.files[0])}
              hidden
            />
          </div>
        </div>
        <p
          style={{
            margin: "0",
            // marginTop: "20px",
            fontWeight: "bold",
          }}
        >
          YoutubeURLs
        </p>
        <div className="aboutUs_allVideos">
          <div className="aboutUs_allVideosCards">
            {urls.map((item, i) => (
              <div key={i} className="aboutUs__youtubeCard">
                <p
                  style={{
                    fontWeight: "bold",
                    fontSize: "15px",
                    marginBottom: "5px",
                  }}
                >
                  {item.title}
                </p>
                <p>{item.description}</p>
                <p
                  onClick={() => window.open(item.url, "_blank")}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "blue",
                    cursor: "pointer",
                    margin: "5px 0",
                  }}
                >
                  Link
                  <OpenInBrowser />
                </p>
                <div
                  className="aboutUs__template__allImages__closeIcon"
                  onClick={() => {
                    setUrls((p) => p.filter((itm) => itm.url !== item.url));
                    setChange(true);
                  }}
                >
                  <Close />
                </div>
              </div>
            ))}
          </div>

          <div className="aboutUs__videoInput">
            <div className="aboutUs__header">
              <input
                placeholder="Title"
                value={videoTitle}
                onChange={(e) => setVideoTitle(e.target.value)}
              />
              <input
                placeholder="URL"
                value={videoURL}
                onChange={(e) => setVideoURL(e.target.value)}
              />
            </div>
            <textarea
              rows="3"
              placeholder="description"
              value={videoDesciption}
              onChange={(e) => setVideoDesciption(e.target.value)}
            />
            <Button
              variant="contained"
              color="secondary"
              disabled={!(videoDesciption && videoTitle && videoURL)}
              onClick={() => {
                setUrls((p) => [
                  ...p,
                  {
                    title: videoTitle,
                    description: videoDesciption,
                    url: videoURL,
                  },
                ]);

                setVideoDesciption("");
                setVideoTitle("");
                setVideoURL("");
                setChange(true);
              }}
            >
              Add
            </Button>
          </div>
        </div>

        <div style={{ textAlign: "right" }}>
          {loading ? (
            <CircularProgress />
          ) : (
            <Button
              variant="contained"
              color="primary"
              disabled={!change}
              onClick={submitHandler}
            >
              Submit
            </Button>
          )}
        </div>
      </div>
    </>
  );
}

export default AboutUsTemplate;
